import { JsonObject } from '@/lib/helpers';
import { createContext, FC, ReactElement } from 'react';

export type ModalType = 'confirm';

export type ModalConfig = {
  key: string;
  Component: FC;
  modalType: ModalType;
  props?: JsonObject;
};

export type ModalElement = {
  key: string;
  element: ReactElement;
};

export type Modal = ModalConfig | ModalElement;

export interface IModalState {
  getModalLink: (linkId: string) => JsonObject | null;
  linkModal: (linkId: string, params?: JsonObject) => void;
  modalIsOpen: (modalType: ModalType) => boolean;
  openModal: <T>(modalType: ModalType, props?: T) => void;
  closeModal: () => void;
  modalStack: Modal[];
}

export const ModalContext = createContext<IModalState>({
  getModalLink: () => null,
  linkModal: () => null,
  modalIsOpen: () => false,
  openModal: () => null,
  closeModal: () => null,
  modalStack: [],
});

export const isModalConfig = (modal: Modal): modal is ModalConfig => {
  return (modal as ModalConfig).modalType !== undefined;
};
